import { recaptchaValidator } from './recaptcha';

/* eslint-disable camelcase */
const ERROR_MESSAGES = {
  crm_school: {
    valueMissing: 'Please select a school.'
  },
  curriculum_preference_check: {
    valueMissing: 'Please select one.'
  },
  delivery_type: {
    valueMissing: 'Please select one.'
  },
  department: {
    valueMissing: 'Please select one.'
  },
  dollar_amount: {
    valueMissing: 'Please enter a dollar amount.',
    patternMismatch: 'Please enter a number with no commas or periods.'
  },
  email: {
    valueMissing: 'Please enter your email address.',
    typeMismatch: 'Please enter a valid email address.',
    patternMismatch: 'Please enter a valid email address.'
  },
  first_name: {
    valueMissing: 'Please enter your first name.',
    patternMismatch: 'Please enter your first name.'
  },
  grade_levels_taught: {
    valueMissing: 'Please select a grade level.'
  },
  grade_levels_taught_check: {
    valueMissing: 'Please select one.'
  },
  impact_of_sponsor: {
    valueMissing: 'Please enter something for this field.'
  },
  last_name: {
    valueMissing: 'Please enter your last name.',
    patternMismatch: 'Please enter your last name.'
  },
  message: {
    valueMissing: 'Please provide a message.'
  },
  number_of_students: {
    valueMissing: 'Please enter a number.'
  },
  ny_resident: {
    valueMissing: 'Please select one.',
    customError: (inputElem, callback) => {
      const instanceId = inputElem.id.split('_')[1];
      const radios = document.querySelectorAll(
        `#ny_resident_${instanceId} [name="ny_resident"]`
      );
      let isNY = false;
      radios.forEach((radio) => {
        if (radio.value === 'yes' && radio.checked) {
          isNY = true;
        }
      });
      const msg = isNY
        ? "Sorry, you aren't eligible to enter the giveaway"
        : '';
      return callback(msg);
    }
  },
  org_name: {
    valueMissing: "Please enter your organization's name.",
    patternMismatch: "Please enter your organization's name."
  },
  org_zip: {
    valueMissing: 'Please enter your zip/postal code.',
    patternMismatch: 'Please enter a valid U.S. or Canada postal code.'
  },
  phone: {
    valueMissing: 'Please enter your phone number.',
    typeMismatch: 'Please enter a valid phone number.',
    patternMismatch: 'Please enter a valid phone number.'
  },
  position: {
    valueMissing: 'Please select the closest match.'
  },
  purchase_time_frame: {
    valueMissing: 'Please select a purchase time frame.'
  },
  purchaser_role: {
    valueMissing: 'Please select your role in buying the curriculum.'
  },
  reason_for_sponsor: {
    valueMissing: 'Please enter something for this field.'
  },
  recaptcha_check: {
    customError: recaptchaValidator
  },
  requested_schools: {
    valueMissing: 'Please enter at least one school name.',
    patternMismatch: 'Please enter at least one school name.'
  },
  school_type: {
    valueMissing: 'Please select a type that best describes your school.'
  },
  self_description_check: {
    valueMissing: 'Please select one.'
  },
  sponsor_request_businesses: {
    valueMissing: 'Please enter at least one business name.',
    patternMismatch: 'Please enter at least one business name.'
  },
  student_quantity_range: {
    valueMissing: 'Please select a range.'
  },
  subjects_check: {
    valueMissing: 'Please select a subject.'
  },
  usage_intent: {
    valueMissing: 'Please select where you plan on using the curriculum.'
  },
  viewer_count: {
    valueMissing: 'Please enter the number of viewers.',
    rangeUnderflow: 'Please enter a number greater than zero.'
  }
};

export { ERROR_MESSAGES };
